<template>
  <div
    v-cloak
    v-if="template && rules"
    class="item-common pt-10 pb-15 px-7 type-education"
  >
    <div class="header">
      <div class="d-flex">
        <h1 class="title">
          {{ $t(template.educationTitle) }}
          <span v-if="itemMaxLength" class="max-length-guide">
            {{ $t('최대 입력 가능 갯수 :') }} {{ $t(itemMaxLength) }}</span
          >
        </h1>
      </div>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideEducation"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <div class="mt-8" v-if="obj">
          <v-row class="mt-2">
            <v-col
              cols="12"
              :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
            >
              <v-row>
                <v-col cols="12" :class="[colclass, collength]">
                  <i-text-field
                    v-maxlength="'education_name'"
                    v-model="obj.educationName"
                    :label="itemLabel('educationName')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('educationName', true),
                      rules.maxlength('educationName'),
                    ]"
                    :class="leftRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col
                  cols="12"
                  :class="[colclass, collength]"
                  v-if="education == 'A'"
                >
                  <i-text-field
                    v-maxlength="'education_org'"
                    v-model="obj.educationOrg"
                    :label="itemLabel('educationOrg')"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[
                      rules.required('educationOrg', true),
                      rules.maxlength('educationOrg'),
                    ]"
                    :class="zeroRoundedClass"
                  ></i-text-field>
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('educationSdate')"
                    useMaxCurrentDate
                    :rules="[rules.required('educationSdate', true)]"
                    v-model="obj.startDate"
                    :type="sdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
                <v-col cols="6" class="col-md-3" :class="colclass">
                  <CommonDatePicker
                    :readonly="isReadonly"
                    :label="itemLabel('educationEdate')"
                    useMaxCurrentDate
                    :rules="[rules.required('educationEdate', true)]"
                    v-model="obj.endDate"
                    :min="obj.startDate"
                    :type="edateFormat === 'YYYY.MM' ? 'month' : 'date'"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col class="d-none d-md-block pl-3 col-md-1">
              <i-btn elevation="0" color="primary" block outlined @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
          <v-row :class="rowclass">
            <v-col cols="12" :class="colclass">
              <i-text-field
                :label="itemLabel('educationDesc')"
                v-model="obj.educationDesc"
                outlined
                dense
                hide-details="auto"
                :rules="[
                  rules.required('educationDesc', true),
                  rules.maxlength('educationDesc'),
                ]"
              ></i-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" class="d-md-none d-block">
              <i-btn elevation="0" color="primary" outlined block @click="add"
                >저장</i-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm">
        <template v-for="(item, i) in educations">
          <v-divider :key="'educationdiv' + i" v-if="i != 0"></v-divider>
          <div class="mt-8" v-if="item" :key="'careeroverseas' + i">
            <v-row class="mt-2">
              <v-col
                cols="12"
                :class="{ 'col-md-11': !isReadonly, 'col-md-12': isReadonly }"
              >
                <v-row>
                  <v-col cols="12" :class="[colclass, collength]">
                    <i-text-field
                      v-maxlength="'education_name'"
                      v-model="item.educationName"
                      :label="itemLabel('educationName')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('educationName'),
                        rules.maxlength('educationName'),
                      ]"
                      @blur="save(i)"
                      :class="leftRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    :class="[colclass, collength]"
                    v-if="education == 'A'"
                  >
                    <i-text-field
                      v-maxlength="'education_org'"
                      v-model="item.educationOrg"
                      :label="itemLabel('educationOrg')"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[
                        rules.required('educationOrg'),
                        rules.maxlength('educationOrg'),
                      ]"
                      @blur="save(i)"
                      :class="zeroRoundedClass"
                    ></i-text-field>
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('educationSdate')"
                      useMaxCurrentDate
                      @change="save(i)"
                      :rules="[rules.required('educationSdate')]"
                      v-model="item.startDate"
                      :type="sdateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                  <v-col cols="6" class="col-md-3" :class="colclass">
                    <CommonDatePicker
                      :readonly="isReadonly"
                      :label="itemLabel('educationEdate')"
                      useMaxCurrentDate
                      :rules="[rules.required('educationEdate')]"
                      @change="save(i)"
                      v-model="item.endDate"
                      :min="item.startDate"
                      :type="edateFormat === 'YYYY.MM' ? 'month' : 'date'"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-none d-md-block pl-3 col-md-1" v-if="!isReadonly">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
            <v-row :class="rowclass">
              <v-col cols="12" :class="colclass">
                <i-text-field
                  :label="itemLabel('educationDesc')"
                  v-model="item.educationDesc"
                  outlined
                  dense
                  hide-details="auto"
                  @blur="save(i)"
                  :rules="[
                    rules.required('educationDesc'),
                    rules.maxlength('educationDesc'),
                  ]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-2" v-if="!isReadonly">
              <v-col cols="12" class="d-md-none d-block">
                <i-btn
                  elevation="0"
                  color="normal"
                  block
                  outlined
                  @click="remove(i)"
                  >삭제</i-btn
                >
              </v-col>
            </v-row>
          </div>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import { mdiCalendarBlank } from '@mdi/js';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';
import { snack } from '@/plugins/dialog/api';
export default {
  components: { CommonDatePicker },
  mixins: [LoadingMixin],
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },

    itemDirectInput: {
      type: Function,
      default: () => {},
    },

    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.education?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.education?.oMaxLength ||
        this.opts.education?.oMaxLength > this.educations.length
      );
    },
    collength: function() {
      return {
        'col-md-6': this.education === 'B',
        'col-md-3': this.education === 'A',
      };
    },
    rowclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    lrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-l':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-r-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    rrzrclass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
        'rounded-r':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
        'rounded-l-0':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
  },
  data: () => ({
    mdiCalendarBlank,
    itemDelimeter: '#',
    education: '',
    itemSeq: 1,
    obj: null,
    educations: [],
    fileUploadYn: '',
    sdateFormat: '',
    edateFormat: '',
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    itemLabel: function(key) {
      var label = this.template[key];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        label =
          this.opts[key].oRequireYn === 'Y'
            ? '*' + this.$t(label)
            : this.$t(label);
      }

      return label;
    },
    itemLength: function(key) {
      var length = 0;
      if (this.opts && this.opts.hasOwnProperty(key)) {
        var defaultLength =
          key.indexOf('file') >= 0 || key.indexOf('File') >= 0 ? 2 : 0;
        length = this.opts[key].oLength
          ? this.opts[key].oLength
          : defaultLength;
      }
      return length;
    },
    itemArray: function(key) {
      var array = [];

      if (this.opts && this.opts.hasOwnProperty(key)) {
        array = this.opts[key].oItems
          ? this.opts[key].oItems.split(this.itemDelimeter)
          : [];
      }
      return array;
    },
    setting: function() {
      if (this.template.typeEducation) {
        this.education = this.template.typeEducation;
      }

      if (this.opts) {
        let $this = this;
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (prop.id.cvColumn === 'educationSdate') {
            $this.sdateFormat = prop.oFormat;
          } else if (prop.id.cvColumn === 'educationEdate') {
            $this.edateFormat = prop.oFormat;
          }
        }
      }
      this.dataSetting();
      this.obj = this.defaultObj();
    },
    dataSetting: function() {
      if (
        this.info &&
        this.info.educations &&
        this.info.educations.length > 0
      ) {
        this.itemSeq = this.info.educations[0].id.seq;
        this.educations = [];

        let $this = this;
        this.info.educations.forEach(function(v) {
          var startDate = '';

          var endDate = '';

          if (v.educationSdate) {
            if ($this.sdateFormat === 'YYYY.MM') {
              startDate =
                v.educationSdate.substring(0, 4) +
                '-' +
                v.educationSdate.substring(4, 6);
            } else if ($this.sdateFormat === 'YYYY.MM.DD') {
              startDate =
                v.educationSdate.substring(0, 4) +
                '-' +
                v.educationSdate.substring(4, 6) +
                '-' +
                v.educationSdate.substring(6, 8);
            }
          }

          if (v.educationEdate) {
            if ($this.edateFormat === 'YYYY.MM') {
              endDate =
                v.educationEdate.substring(0, 4) +
                '-' +
                v.educationEdate.substring(4, 6);
            } else if ($this.edateFormat === 'YYYY.MM.DD') {
              endDate =
                v.educationEdate.substring(0, 4) +
                '-' +
                v.educationEdate.substring(4, 6) +
                '-' +
                v.educationEdate.substring(6, 8);
            }
          }

          let obj = {
            seq: v.id.seq,
            educationName: v.educationName,
            educationOrg: v.educationOrg,
            educationDesc: v.educationDesc,
            educationSdate: v.educationSdate,
            educationEdate: v.educationEdate,
            start: '',
            end: '',
            startDate: startDate,

            endDate: endDate,
          };

          $this.educations.push(obj);
          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      let obj = {
        seq: this.itemSeq++,
        educationName: '',
        educationOrg: '',
        educationDesc: '',
        educationSdate: '',
        educationEdate: '',
        start: '',
        end: '',
        startDate: '',

        endDate: '',
      };
      return obj;
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          '최대 입력 가능 갯수 : ' + `${this.opts.education.oMaxLength}`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    valid: function() {
      if (
        this.opts &&
        this.opts.education &&
        this.opts.education.oRequireYn &&
        this.opts.education.oRequireYn == 'Y' &&
        this.educations.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      return this.$refs.updateForm.validate();
    },
    async save(i) {
      await this.$nextTick();
      var item = i === -1 ? this.obj : this.educations[i];

      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;

      const id = {
        annoId: this.$route.params.annoId,
        seq: item.seq,
      };

      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      const p = {
        id: id,
        educationName: item.educationName,
        educationSdate: item.startDate.replace(pattern, ''),
        educationEdate: item.endDate.replace(pattern, ''),
        educationOrg: item.educationOrg,
        educationDesc: item.educationDesc,
      };

      this.$emit('save', p, 'education', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('EDUCATION SAVE FAIL');
      } else snack.info(`저장되었습니다.`);
      //SAVE FORM
      if (i === -1) {
        this.educations.push(this.obj);
        this.obj = this.defaultObj();
        this.$refs.saveForm.resetValidation();
      }
    },
    delete: function(i) {
      this.showLoading();
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.educations[i].seq,
      };

      this.$emit('delete', p, 'education', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('EDUCATION DELETE FAIL');
      } else {
        snack.danger(`삭제되었습니다.`);
        this.educations.splice(i, 1);
      }
      this.hideLoading();
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}

.type-career .sub-title-standard {
  position: relative;
}
.type-career .sub-title-standard .v-input__slot {
  padding-left: 100px !important;
}
.type-career .sub-title-standard .sub-title {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #363c43;
}
</style>
